export default {
  state() {
    return {
      isShow: false,
    }
  },

  getters: {
    isShowProfileModal: ({ isShow }) => isShow
  },

  mutations: {
    setShowProfileModal(state, value) {
      state.isShow = value;
    }
  },

  actions: {
    setShowProfileModal({ commit }, value) {
      commit('setShowProfileModal', value);
    }
  },

  namespaced: true
}
